import { render, staticRenderFns } from "./addOrganisation.vue?vue&type=template&id=16db5263&scoped=true"
import script from "./addOrganisation.vue?vue&type=script&lang=js"
export * from "./addOrganisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16db5263",
  null
  
)

export default component.exports